import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import ClearIcon from './clear_filter_icon';

export class FilterButton extends React.Component {
  static propTypes = {
    'aria-label': PropTypes.string,
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    constantWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    filtersApplied: PropTypes.bool,
    filterTag: PropTypes.string,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    name: PropTypes.string.isRequired,
    selectedLength: PropTypes.number,
    onClear: PropTypes.func
  };

  render() {
    return (
      <OverlayTrigger
        name={this.props.name}
        overlay={this.renderPopover()}
        placement="bottom"
        rootClose
        trigger={this.props.disabled ? [] : 'click'}
      >
        <div
          aria-label={this.props['aria-label'] || this.props.label}
          className={classNames(
            { disabled: this.props.disabled },
            'left-buffer-md filter-btn btn btn-light',
            this.props.className
          )}
        >
          <div className="filter-btn-text">
            {this.props.label}
            {this.renderFilterTag()}
          </div>
          <div>
            {this.renderButton()}
          </div>
        </div>
      </OverlayTrigger>
    );
  }

  renderFilterTag() {
    if (this.props.filterTag) {
      return (
        <span className="pl-1">
          ({this.props.filterTag})
        </span>
      );
    } else if (this.props.selectedLength) {
      return (
        <span className="pl-1">
          ({this.props.selectedLength})
        </span>
      );
    } else if (this.props.constantWidth || this.props.filtersApplied) {
      return (
        <div className={classNames('filter-dot', { invisible: !this.props.filtersApplied })}>
          <FontAwesomeIcon icon={faCircle} size="xs" />
        </div>
      );
    }
  }

  renderPopover() {
    return (
      <Popover className={this.props.name} id={this.props.name}>
        <div className="filter-button-popover top-buffer-sm row right-buffer-sm left-buffer-sm">
          {this.props.children}
        </div>
      </Popover>
    );
  }

  renderButton() {
    if (this.props.onClear) {
      return <ClearIcon onClear={this.props.onClear}/>;
    }

    return <span className="caret"/>;
  }
}

export default FilterButton;
